import { useTranslation } from 'react-i18next';

/**
 * §6.4 섹션 2 — GitLab read 권한 신청 절차 (연락처/규약은 i18n 하드코딩 신뢰 문자열).
 * 실제 발급은 운영자 오프라인 처리 — 본 컴포넌트는 안내만 한다.
 */
export function AccessRequestSteps() {
  const { t } = useTranslation();

  const steps = [
    t('gettingStartedGuide.access.steps.target'),
    t('gettingStartedGuide.access.steps.requestTo'),
    t('gettingStartedGuide.access.steps.accountRule'),
    t('gettingStartedGuide.access.steps.afterApproval'),
  ];

  return (
    <section aria-labelledby="gsg-access-heading">
      <h2
        id="gsg-access-heading"
        style={{ margin: '0 0 var(--spacing-2) 0', fontSize: 'var(--font-size-lg)', color: 'var(--color-text-primary)' }}
      >
        {t('gettingStartedGuide.access.heading')}
      </h2>
      <p style={{ margin: '0 0 var(--spacing-3) 0', fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
        {t('gettingStartedGuide.access.contact')}
      </p>
      <ol style={{ margin: 0, paddingLeft: 'var(--spacing-6)', display: 'flex', flexDirection: 'column', gap: 'var(--spacing-2)' }}>
        {steps.map((step, i) => (
          <li key={i} style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-primary)' }}>
            {step}
          </li>
        ))}
      </ol>
    </section>
  );
}
